import { render, staticRenderFns } from "./docPutDetail.vue?vue&type=template&id=45217c16&scoped=true"
import script from "./docPutDetail.vue?vue&type=script&lang=js"
export * from "./docPutDetail.vue?vue&type=script&lang=js"
import style0 from "./docPutDetail.vue?vue&type=style&index=0&id=45217c16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45217c16",
  null
  
)

export default component.exports